
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'CategorySlider',
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
    selected: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fixed: false,
      swiper_options: {
        threshold: 10,
        resizeObserver: true,
        slidesPerView: 'auto',
        scrollbar: {
          draggable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        wrapperClass: 'swiper-wrapper',
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            scrollbar: {
              draggable: true,
            },
          },
          992: {
            spaceBetween: 20,
            slidesPerView: 3.5,
          },
          1200: {
            spaceBetween: 20,
            slidesPerView: 4,
          },
        },
      },
    }
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleClick(e) {
      this.$emit('selected', e.target.id)
    },
  },
}
